import { render, staticRenderFns } from "./attachmentList.vue?vue&type=template&id=53e3b658"
import script from "./attachmentList.vue?vue&type=script&lang=js"
export * from "./attachmentList.vue?vue&type=script&lang=js"
import style0 from "./attachmentList.vue?vue&type=style&index=0&id=53e3b658&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports